export default __webpack_public_path__ + "static/media/zilius-full.010305f2.png";